var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngryEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.5 48.5",
    style: {
      enableBackground: "new 0 0 48.5 48.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FCBD30;}\n\t.st1{opacity:0.3;fill:#EA3219;enable-background:new    ;}\n\t.st2{fill:#EA3219;}\n\t.st3{fill:none;stroke:#EA3219;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,299.1c-12,0-21.9-9.2-22.9-21c-0.1,0.7-0.1,1.3-0.1,2c0,12.7,10.3,23,23,23s23-10.3,23-23 c0-0.7,0-1.3-0.1-2C46.1,289.8,36.2,299.1,24.2,299.1z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 24.2,
    cy: 24.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.2,4.2c-11,0-20,9-20,20s9,20,20,20s20-9,20-20S35.2,4.2,24.2,4.2z M24.2,42.5 c-10.1,0-18.3-8.2-18.3-18.3S14.1,5.9,24.2,5.9s18.3,8.2,18.3,18.3S34.3,42.5,24.2,42.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 30.5,
    cy: 19.2,
    rx: 2.1,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 18,
    cy: 19.2,
    rx: 2.1,
    ry: 2.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.2,35.7c-1.8-4-5.5-6.8-9.9-6.8s-8.2,2.8-9.9,6.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryEmoji);
export default __webpack_public_path__ + "static/media/angry-emoji.e2689a846ecf858a9362933fc1194738.svg";
export { ForwardRef as ReactComponent };